import { ChatMessageType } from "@utilities/types";
import React, { createContext, useState, PropsWithChildren } from "react";

interface AssistantContextType {
    messages: ChatMessageType[];
    setMessages: React.Dispatch<React.SetStateAction<ChatMessageType[]>>;
}

export const AssistantContext = createContext<AssistantContextType>({
    messages: [],
    setMessages: () => { }
});

export const AssistantContextProvider: React.FC<PropsWithChildren> = ({ children }) => {

    const [messages, setMessages] = useState<ChatMessageType[]>([]);

    return (
        <AssistantContext.Provider
            value={{
                messages, setMessages
            }}
        >
            {children}
        </AssistantContext.Provider>
    );
};
